//import React from 'react';
import Skeleton from '../../common/skeleton';
import { Col } from 'react-bootstrap';

const ButtonSkeleton = () => (
  <>
    <Col sm={12}>
      <Skeleton
        count={1}
        height={37}
        containerClassName={'add-button-active reports-blob-button'}
      />
    </Col>
  </>
);

export default ButtonSkeleton;
